import React from 'react';

// Import route protection components
import { CompanyRoleRoute } from '../components/routes/CompanyRoleRoute';
import { StudentRedirectRoute } from '../components/routes/StudentRedirectRoute';
import { AdminRoute } from '../components/admin/AdminRoute';
import { BackendRoute } from '../components/admin/BackendRoute';

// Import types
import type { RouteConfig } from './types';

interface RouteGuardProps {
  config: RouteConfig;
  children: React.ReactNode;
}

/**
 * Unified route guard that applies the appropriate protection based on guardType
 * Consolidates all route protection logic into a single component
 */
export function RouteGuard({ config, children }: RouteGuardProps) {
  const { guardType, allowedRoles } = config;

  switch (guardType) {
    case 'companyRole':
      return (
        <CompanyRoleRoute allowedRoles={allowedRoles ?? []}>
          {children}
        </CompanyRoleRoute>
      );

    case 'adminOnly':
      return (
        <AdminRoute>
          {children}
        </AdminRoute>
      );

    case 'backendOnly':
      return (
        <BackendRoute>
          {children}
        </BackendRoute>
      );

    case 'studentRedirect':
      return (
        <StudentRedirectRoute>
          {children}
        </StudentRedirectRoute>
      );

    case 'none':
    default:
      // No protection needed
      return children;
  }
}